module.exports = __webpack_public_path__ + "img/pay2.846e05a2.png";